import React from "react";
import { MessageSquare, ChevronUp, X } from "lucide-react";
import { useChatStore } from "./chatStore";

export const ChatMiniBar: React.FC = () => {
  const isMinimized = useChatStore((s) => s.isMinimized);
  const activeSession = useChatStore((s) => s.activeSession);
  const lastPreview = useChatStore((s) => s.lastPreview);
  const hasUnread = useChatStore((s) => s.hasUnread);
  const restore = useChatStore((s) => s.restore);
  const closeChat = useChatStore((s) => s.closeChat);

  if (!isMinimized) return null;

  return (
    <div
      className="fixed bottom-4 right-4 z-50 flex items-center gap-2 bg-background border border-border rounded-lg shadow-lg px-3 py-2 cursor-pointer hover:shadow-xl transition-shadow"
      style={{ width: 300, height: 48 }}
      onClick={restore}
      role="button"
      tabIndex={0}
      aria-label="Expand chat"
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") restore();
      }}
    >
      <div className="relative shrink-0">
        <MessageSquare className="size-4 text-primary" />
        {hasUnread && (
          <span className="absolute -top-1 -right-1 size-2.5 bg-primary rounded-full" />
        )}
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-xs font-semibold text-foreground truncate">
          {activeSession?.title || "AI Assistant"}
        </p>
        {lastPreview && (
          <p className="text-[11px] text-muted-foreground truncate">{lastPreview}</p>
        )}
      </div>
      <button
        onClick={(e) => {
          e.stopPropagation();
          restore();
        }}
        className="p-1 rounded hover:bg-muted transition-colors shrink-0"
        aria-label="Expand"
      >
        <ChevronUp className="size-3.5" />
      </button>
      <button
        onClick={(e) => {
          e.stopPropagation();
          closeChat();
        }}
        className="p-1 rounded hover:bg-muted transition-colors shrink-0"
        aria-label="Close"
      >
        <X className="size-3.5" />
      </button>
    </div>
  );
};
